import React from 'react';
import iconify from '../iconify';

const ChevronDown = props => (
  <svg width="1em" height="0.55em" viewBox="0 0 80.728 44.248" {...props}>
    <path
      fill="none"
      stroke="#ea4154"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="8px"
      d="M.8 73.528l36.248-36.48L.8.8"
      transform="rotate(90 37.163 40.364)"
    />
  </svg>
);

export default iconify(ChevronDown);
